import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../reducers/user';
import type { StoreDispatch, StoreState } from '../store';
import * as styles from '../styles/form.module.scss';

interface Props {
  title: string;
  description?: string;
}

const UserLevelError: React.FC<Props> = ({ title, description }) => {
  const dispatch = useDispatch<StoreDispatch>();
  const logoSrc = useSelector(
    (state: StoreState) => state.branding.partnerLogoSrc || '',
  );

  // TODO correct brand name here
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <img alt='Logo' className={styles.logo} src={logoSrc} />
        <div className={styles.form}>
          <div className={styles.form_content}>
            <h2 className={styles.title_smaller}>{title}</h2>
            <div className={styles.form_body}>{description}</div>
            <div className={styles.button_container}>
              <button
                className={styles.btn__primary}
                onClick={() => {
                  dispatch(logout());
                }}
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLevelError;
